import { CheckCircleIcon, WarningIcon, AlertCircleIcon } from '../Icons';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export const StatusIcon = _ref => {
  let {
    status
  } = _ref;
  const iconClass = classNames('ds-u-margin-right--1', {
    'ds-c-icon-color--success': status === 'use',
    'ds-c-icon-color--warn': status === 'caution',
    'ds-c-icon-color--error': status === 'avoid'
  });
  const iconStyle = {
    height: '1em',
    width: '1em',
    verticalAlign: 'text-bottom'
  };
  if (status === 'use') return /*#__PURE__*/_jsx(CheckCircleIcon, {
    className: iconClass,
    style: iconStyle
  });
  if (status === 'caution') return /*#__PURE__*/_jsx(WarningIcon, {
    className: iconClass,
    style: iconStyle
  });
  if (status === 'avoid') return /*#__PURE__*/_jsx(AlertCircleIcon, {
    className: iconClass,
    style: iconStyle
  });
  return null;
};